document.addEventListener('DOMContentLoaded', () => {
  if (window.Splide) {
    document.querySelectorAll('.splide').forEach(el => {
      new Splide(el).mount();
    });
  }
});

const initSlideshowNested = (container) => {
  const splideEl = container.querySelector('.splide');
  if (!splideEl || !window.Splide) return;

  const fade     = container.dataset.fade === 'true';
  const autoplay = container.dataset.autoplay === 'true';
  const interval = parseInt(container.dataset.interval, 10) || 5000;
  const arrows   = container.dataset.arrows === 'true';
  const dots     = container.dataset.dots === 'true';

  new Splide(splideEl, {
    type: fade ? 'fade' : 'loop',
    autoplay,
    interval,
    arrows,
    pagination: dots,
    speed: 600,
  }).mount();
};

// Shopify Sections API güvenli kullanım
document.addEventListener('DOMContentLoaded', () => {
  if (window.Shopify?.theme?.sections) {
    Shopify.theme.sections.onLoad('slideshow-nested', (section) => {
      initSlideshowNested(section.container);
    });

    Shopify.theme.sections.onSelect('slideshow-nested', (section) => {
      initSlideshowNested(section.container);
    });
  }
});
